import React, { Component } from 'react';
import logoWhite from '../images/logo-white.png';
import BumperStickers from '../images/marketing/bumperStickers.png';
import './FooterRedesign.css';

class Footer extends Component {
  render() {
    const currentYear = new Date().getFullYear();
    return (
      <div className="ep-footer-shell">
        <footer className="ep-footer">
          <div className="ep-footer-grid">
            <div className="ep-footer-brand">
              <a href="/" aria-label="EditPage home">
                <img className="ep-footer-logo" src={logoWhite} alt="EditPage" />
              </a>
              <p>
                EditPage is a simple, easy and affordable website builder.
                Click, edit, and publish in minutes.
              </p>
            </div>

            <div className="ep-footer-col">
              <h2>Product</h2>
              <a href="/features">Features</a>
              <a href="/pricing">Pricing</a>
              <a href="/webbuilder">Website Builder</a>
              <a href="/webhosting">Web Hosting</a>
              <a href="/emailhosting">Email Hosting</a>
              <a href="/marketing">Marketing</a>
              <a href="/agentic-commerce">Agentic Commerce</a>
              <a href="/onlinestore">Online Store</a>
              <a href="/domain">Domain Registration</a>
            </div>

            <div className="ep-footer-col">
              <h2>Company</h2>
              <a href="/about">About EditPage</a>
              <a href="/press">Press</a>
              <a href="/jobs">Jobs</a>
              <a href="/terms">Terms of Use</a>
              <a href="/privacy">Privacy Policy</a>
            </div>

            <div className="ep-footer-col">
              <h2>Social</h2>
              <a
                target="_blank"
                rel="noopener noreferrer"
                href="https://www.instagram.com/editpagehq/"
              >
                Instagram
              </a>
              <a
                target="_blank"
                rel="noopener noreferrer"
                href="https://www.facebook.com/editpagehq"
              >
                Facebook
              </a>
              <a
                target="_blank"
                rel="noopener noreferrer"
                href="https://twitter.com/editpagehq"
              >
                Twitter
              </a>
              <a
                target="_blank"
                rel="noopener noreferrer"
                href="https://www.youtube.com/channel/UCNh64lJCWeEevmYcsX8a0aw"
              >
                YouTube
              </a>
            </div>

            <div className="ep-footer-col">
              <h2>Support</h2>
              <a href="/support">Support Center</a>
              <a href="/contact">Contact Us</a>
            </div>
          </div>
        </footer>

        <div className="ep-footer-bottom">
          <p>
            © {currentYear} Copyright.
            {' '}
            <a
              className="ep-footer-bottom-link"
              href="https://www.editpage.com"
              target="_blank"
              rel="noopener noreferrer"
            >
              EditPage.com
            </a>
          </p>
          <img className="ep-footer-payments" src={BumperStickers} alt="Accepted payment methods" />
        </div>
      </div>
    );
  }
}

export default Footer;
